import BulkUploadCarrierChangeManager from "../../../views/BulkUploadCarrierChangeManager.js";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const BulkUploadCarrierChangeManagerRoutes = [
  {
    menuName: MenuNames.BULK_UPLOAD_CARRIER_CHANGE_MANAGER,
    path: "/bulk-upload-carrier-change-manager",
    component: BulkUploadCarrierChangeManager,
    exact: true,
  },
];

export default BulkUploadCarrierChangeManagerRoutes;
